export const getPipelineLeadOptions = (pipelines, pipelineLeads) => {
  return (pipelineLeads || []).map((pipelineLead) => {
    const pipeline = pipelines.find((n) => n.id === pipelineLead.pipeline_id) || {};
    const stageName = ((pipeline.stages || []).find((n) => n.id === pipelineLead.stage_id) || {}).pipeline_stage_name;
    return {
      value: pipelineLead.id,
      label: `${pipeline.pipeline_name} ⇢ ${stageName || ''}`,
    };
  });
};
